'use strict'

import $ from 'jquery'

const habilitiesIndex = {
  init() {
    $('.js-see--more').on('click', function(e){
      e.preventDefault();
      $('#' + $(this).attr('data-id')).removeClass('s-habilities--list-closed');
      $('#card-' + $(this).attr('data-id')).removeClass('s-habilities--card-closed');
      $(this).css('display', 'none');
    });
  }
}

export default habilitiesIndex